import { css } from "lit";

/**
 * Shared styles for rendering a list of sent chat attachments inside a message
 * bubble. Consumed by community-chat and live-chat. The paperclip/chip UI inside
 * the input itself is in `chat-message-input.css.ts`.
 */
export const chatAttachmentStyles = css`
  .attachments {
    list-style: none;
    margin: var(--sds-size-space-200) 0 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-150);
  }

  .attachment-link {
    display: inline-flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    padding: var(--sds-size-space-200) var(--sds-size-space-300);
    background: var(--sds-color-background-default-secondary);
    border-radius: var(--sds-size-radius-200);
    color: var(--sds-color-text-default-default);
    text-decoration: none;
    font-size: var(--sds-typography-body-size-small);
    max-width: 100%;
  }

  .attachment-link:hover {
    background: var(--sds-color-background-default-tertiary);
  }

  .attachment-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 200px;
  }

  .attachment-size {
    color: var(--sds-color-text-default-tertiary);
    font-variant-numeric: tabular-nums;
    flex-shrink: 0;
  }
`;
